var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from 'react';
import { wrapEvent } from "../../utils";
import { Flex, Box } from '../Box';
import { Text } from '../Text';
function buildLss(_a, isFocused) {
    var disabled = _a.disabled, isTouched = _a.isTouched, isInvalid = _a.isInvalid, lss = _a.lss;
    return __assign({ position: 'relative', display: 'inline-flex', width: '100%', alignItems: 'center', minHeight: '40px', border: 'regular', borderColor: isTouched && isInvalid
            ? 'danger500'
            : isFocused
                ? 'secondary500'
                : undefined, borderRadius: 'sm', bg: disabled ? 'gray200' : 'white', textScale: 'control', lineHeight: 1, color: disabled ? 'gray200' : undefined, boxShadow: function (_a) {
            var theme = _a.theme;
            return isFocused && isTouched && isInvalid
                ? "inset 0 1px 1px " + theme.colors.gray300 + ", 0 0 0px 2px " + theme.colors.danger100
                : isFocused
                    ? "inset 0 1px 1px " + theme.colors.gray300 + ", 0 0 0 2px " + theme.colors.secondary100 + ", 0 1px 0 " + theme.colors.white
                    : undefined;
        }, cursor: disabled ? 'not-allowed' : undefined }, lss);
}
export var InputWrapper = React.forwardRef(function (_a, ref) {
    var onFocus = _a.onFocus, onBlur = _a.onBlur, isFormik = _a.isFormik, containerLss = _a.containerLss, props = __rest(_a, ["onFocus", "onBlur", "isFormik", "containerLss"]);
    var _b = __read(useState(props.isFocused || false), 2), isFocused = _b[0], setIsFocused = _b[1];
    useEffect(function () {
        setIsFocused(props.isFocused || false);
    }, [props.isFocused]);
    return (React.createElement(Flex, { lss: __assign({ flexDirection: 'column', width: '100%' }, containerLss) },
        React.createElement(Box, __assign({}, props, { ref: ref, lss: buildLss(props, isFocused), onFocus: wrapEvent(onFocus, function () { return setIsFocused(true); }), onBlur: wrapEvent(onBlur, function () { return setIsFocused(false); }) })),
        !isFormik && (React.createElement(Text, { lss: { textScale: 'control', color: 'danger500' } }, props.error))));
});
//# sourceMappingURL=InputWrapper.js.map